import { Button, Grid } from "@mui/material";
import { useEffect } from "react";
import RubricaEvaluacionCardImg from "../../components/UmmIApps/Cards/RubricaEvaluacionCardImg.png";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GetAsignaturas from "../../data/GetAsignaturas";
import GetNiveles from "../../data/GetNiveles";
import AdaptacionesCurriculares from "../../components/Form/Fields/AdaptacionesCurriculares";
import CriteriosEvaluacion from "../../components/Form/Fields/CriteriosEvaluacion";
import DescripcionTarea from "../../components/Form/Fields/DescripcionTarea";
import PuntosEscala from "../../components/Form/Fields/PuntosEscala";
import TipoTarea from "../../components/Form/Fields/TipoTarea";
import TituloRubrica from "../../components/Form/Fields/TituloRubrica";
import GetObjetivosAprendizaje from "../../components/ObjetivosAprendizaje/GetObjetivosAprendizaje";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";

const RubricaEvaluacionPage = () => {
  const {
    nivelId,
    materiaId,
    handleBack,
    promptData,
    toggleCamposAvanzados,
    mostrarCamposAvanzados,
    setTextoInicial,
    isOAAdded,
    handleNivelChange,
    handleAsignaturaChangeLocal,
    handleInitialPromptData,
  } = useActividadesContext();

  //Variable para condicionar la habilitación del botón "Generar"
  const isButtonDisabled = !(
    promptData.nivel &&
    promptData.materia &&
    promptData.tipo_actividad &&
    promptData.nivel_desempeno &&
    isOAAdded
  );
  const colorIconBack = "#E29930";

  useEffect(() => {
    const init = {
      titulo: "",
      nivel: "",
      materia: "",
      objetivos: [],
      nivel_desempeno: 3,
      adaptaciones_curriculares: "",
      criterios_evaluacion: [],
      descripcion_actividad: "",
      tipo_actividad: "",
    };
    handleInitialPromptData(init, "rubrica");
    setTextoInicial(
      "Esta es la propuesta que tengo para ti. Puedes revisarla y modificar cualquier parte según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={RubricaEvaluacionCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #F8ED9B 100%, #F1DB37 100%)"
        }
        titleColor="#F9A825"
        title="Rúbrica de evaluación"
        description="Diseña un instrumento de evaluación que te permita analizar y reflexionar de manera sistemática y profunda sobre la calidad del trabajo realizado por tus estudiantes"
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <Grid item xs={12} lg={12} display="flex" flexDirection="row">
          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mr: 2, mb: 4 }}>
            <GetNiveles
              onNivelChange={handleNivelChange}
              selectedNivel={nivelId}
            />
          </Grid>

          {/* Nuevo componente para consultar y probar el endpoint de asignaturas */}
          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mb: 4 }}>
            <GetAsignaturas
              nivelId={nivelId}
              onAsignaturaChange={handleAsignaturaChangeLocal}
              selectedAsignatura={materiaId}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <GetObjetivosAprendizaje
            nombreAsignatura={promptData.materia}
            nombreNivel={promptData.nivel}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ mb: 3 }}>
          <TipoTarea />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ mb: 3 }}>
          <PuntosEscala />
        </Grid>
        <Grid item xs={12} container justifyContent="center" sx={{ mb: 3 }}>
          <Button
            variant="text"
            sx={{ color: "#336B87" }}
            onClick={toggleCamposAvanzados}
            endIcon={
              mostrarCamposAvanzados ? <ExpandMoreIcon /> : <ExpandMoreIcon />
            }
          >
            {mostrarCamposAvanzados
              ? "Ocultar opciones avanzadas"
              : "Mostrar opciones avanzadas (opcional)"}
          </Button>
        </Grid>
        {/* Campos avanzados */}
        {mostrarCamposAvanzados && (
          <>
            <Grid item xs={12}>
              <TituloRubrica />
            </Grid>
            <Grid item xs={12}>
              <DescripcionTarea />
            </Grid>
            <Grid item xs={12}>
              <CriteriosEvaluacion />
            </Grid>
            <Grid item xs={12}>
              <AdaptacionesCurriculares />
            </Grid>
          </>
        )}
      </UmmiaAppsLayout>
    </>
  );
};

export default RubricaEvaluacionPage;
